import React from 'react';

import { MenuSectionGridItem } from 'features/menu/components/menu-section/menu-section-grid-item';
import { MenuSectionListItem } from 'features/menu/components/menu-section/menu-section-list-item';
import { IMenuSectionProps } from 'features/menu/components/menu-section/types';
import { MenuTileGridHeader } from 'features/menu/components/menu-tile-grid/menu-tile-grid-header';
import { Separator } from 'features/menu/components/menu-tile-grid/separator';
import { MENU_TILE_GRID_HALF_GAP } from 'features/menu/components/menu-tile-grid/styled';
import { FlatList } from 'react-native';

import { centeredRowContainerStyles } from 'components/layout/centered-row-container';
import LoadingAnimation from 'components/loading-animation';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { spacing } from 'styles/constants';

// NEW one menu
export const MenuSection = React.memo<IMenuSectionProps>(({ data, pullToReloadProps }) => {
  const isMobile = useIsMobileBreakpoint();
  return (
    <FlatList
      key={isMobile ? 'mobile-list' : 'desktop-list'}
      data={data}
      {...pullToReloadProps}
      style={{ flex: 1, marginHorizontal: isMobile ? 0 : MENU_TILE_GRID_HALF_GAP * -1 }}
      contentContainerStyle={[centeredRowContainerStyles.content, { alignSelf: 'center' }]}
      ListHeaderComponent={<MenuTileGridHeader />}
      ItemSeparatorComponent={isMobile ? Separator : null}
      ListFooterComponent={isMobile ? Separator : null}
      numColumns={isMobile ? 1 : 3}
      ListEmptyComponent={<LoadingAnimation paddingY={spacing.$4} />}
      showsVerticalScrollIndicator={false}
      keyExtractor={section => section.id}
      renderItem={({ item }) => {
        if (isMobile) {
          return <MenuSectionListItem item={item} />;
        }
        return <MenuSectionGridItem item={item} />;
      }}
    />
  );
});
